<template>
  <div id="seven4GameContainer" style="width: 100%; height: 100%;">
    <div class="error-message" v-if="errorStatus">
      <h3>{{ errorStatus }}</h3>
      <div>Try reloading game or return to casino lobby</div>
    </div>
  </div>
</template>

<script>
import titleMixin from '@/mixins/titleMixin';
import NGT from './ngt-subscriber.js';

export default {
  name: 'Seven4View',
  mixins: [titleMixin],
  title() {
    const routeQuery = this.$route.query;
    return routeQuery.gameName ? `${routeQuery.gameName}` : '7777 Gaming';
  },
  data: () => ({
    errorStatus: ''
  }),
  computed: {
    closeUrl() {
      return this.$route.query.closeurl || '';
    }
  },
  mounted() {
    const appWrapper = document.querySelector('.app-wrapper');
    appWrapper.classList.add('overflow-hidden');
    document.body.classList.add('seven4-open');

    this.initNGTGame();
  },
  beforeDestroy() {
    document.body.classList.remove('seven4-open');
  },
  methods: {
    initNGTGame() {
      const fullGameURL = this.$route.query.gameURL || '';
      
      if (!fullGameURL) {
        this.errorStatus = 'Game URL not provided';
        return;
      }

      try {
        const { baseUrl, params } = this.parseGameUrl(fullGameURL);
        
        const settings = {
          game: params.game || params.id || '',
          lang: params.lang_label || params.lang || 'EN',
          currency: params.currency_label || params.currency || 'EUR',
          longToken: params.o_lt || params.longToken || '',
          market_label: params.market_label || ''
        };

        if (this.closeUrl) {
          settings.homeURL = this.closeUrl;
        }

        const isDemo = !settings.longToken;

        if (isDemo) {
          console.log('Demo mode - loading game directly:', fullGameURL);
          this.loadDemoGame(fullGameURL);
        } else {
          console.log('NGT.create() with baseUrl:', baseUrl);
          console.log('NGT.create() with settings:', settings);

          NGT.create('#seven4GameContainer', baseUrl, settings);

          NGT.subscribe((action, data) => {
            console.log('NGT Event:', action, data);
          });
        }

      } catch (err) {
        this.errorStatus = 'Failed to initialize game';
        console.error('NGT initialization error:', err);
      }
    },
    loadDemoGame(url) {
      const container = document.querySelector('#seven4GameContainer');
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.style.border = 'none';
      iframe.className = 'seven4-game-frame';
      container.appendChild(iframe);
    },
    parseGameUrl(fullUrl) {
      const url = new URL(fullUrl);
      const baseUrl = url.origin + url.pathname;
      const params = {};
      
      url.searchParams.forEach((value, key) => {
        params[key] = value;
      });

      return { baseUrl, params };
    }
  }
}
</script>

<style lang="scss">
.seven4-open {
  overflow: hidden;
}

#seven4GameContainer {
  width: 100%;
  height: 100%;
  position: relative;
}

.seven4-game-frame {
  width: 100%;
  height: 100%;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
}

.overflow-hidden {
  overflow: hidden;
}

.error-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #17171b;
}
</style>
